import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';

const { shopCartConf } = httpApi.shopping;

// 获取最近在玩游戏
export interface userGameParams {
  keyword?: string;
  page: number;
  size: number;
}

export function userGame(params: userGameParams) {
  return request<ListDataJson<userGameList>>({
    method: 'GET',
    url: httpApi.tradingBankMybox.userGame,
    params
  });
}

export interface ZqMsgProps {
  title: string;
  content: string;
  url: string;
}

export interface ListDataJson<T> {
  current_page?: number;
  data: T[];
  last_page?: number;
  per_page?: string;
  total: number;
  zq_msg?: ZqMsgProps;
}

export interface userGameList {
  box_game_id: string;
  game_logo_url: string;
  game_name: string;
  main_serverid: string;
  server_name: string;
  serverid: string;
  download_android?: boolean;
  download_ios?: boolean;
  download_pc?: boolean;
  game_tags?: string;
  game_version_name?: string;
  play_game?: number;
}

// 获取全部游戏
export function allGameList(params: userGameParams) {
  return request<allGameListJson>({
    method: 'GET',
    url: httpApi.tradingBankMybox.allGameList,
    params
  });
}

export interface allGameListJson {
  game_list: ListDataJson<userGameList>;
}

interface gameServerListParams {
  box_game_id?: string;
  server_name?: string;
}

// 获取游戏区服
export function gameServerList(params: gameServerListParams) {
  return request<allServerJson>({
    method: 'GET',
    url: httpApi.tradingBankMybox.gameServerList,
    params
  });
}

// 获取游戏区服
export interface ServerPageListData {
  box_game_id?: string;
  server_name: string;
  page: number;
  size: number;
}

export interface ServerItem {
  serverid: number | string;
  server_name: string;
  play_game: number;
}

interface ServerPageJson {
  total: number;
  curr_page: number;
  last_page: number;
  list: ServerItem[];
}

export function getServerPageList(data: ServerPageListData) {
  return request<ServerPageJson>({
    method: 'POST',
    url: httpApi.tradingBankMybox.getServerPageList,
    data
  });
}

interface allServerJson {
  list: userGameList[];
  login_list: userGameList[];
}

// 区服模糊查询
export function FindServer(params: gameServerListParams) {
  return request<userGameList[]>({
    method: 'GET',
    url: httpApi.tradingBankMybox.FindServer,
    params
  });
}

export interface commodityConfigListJson {
  coin_type_name: string;
  role_type_name: string;
  id: string;
}
export interface equipConfigListJson {
  id: string;
  name: string;
}

export interface commodityConfigJson {
  coin: commodityConfigListJson[];
  role: commodityConfigListJson[];
  equip: equipConfigListJson[];
}

// 获取商品筛选项
export function commodityConfig(params: gameServerListParams) {
  return request<commodityConfigJson>({
    method: 'GET',
    url: httpApi.tradingBankMybox.commodityConfig,
    params
  });
}

export interface commodityListParams {
  box_game_id?: string;
  server_id?: string;
  role_config_id: string;
  coin_config_id: string;
  equip_type_id: string;
  order_price?: string;
  page: number;
  size: number;
  min_price?: string;
  max_price?: string;
  title?: string;
  order_time?: string;
  unit_price?: string;
}

export interface infoDataJson {
  order_price: string;
  unit_price: string;
  page: number;
  size: number;
}

export interface MainTagJson {
  code: 'cost_effective' | 'hot' | 'new';
  name: string;
}

export interface commodityListJson {
  collect_times: number;
  commodity_career: string;
  commodity_detail: string;
  commodity_title: string;
  create_time: string;
  game_name: string;
  id: number;
  image: string;
  price: string;
  role: string;
  server_id: number;
  server_name: string;
  sex: number;
  status: number;
  status_ch: string;
  type: number;
  type_ch: string;
  uid: number;
  username: string;
  equip_type_ch: string;
  title: string;
  single_price: string;
  game_type: number;
  my_commodity: number;
  shop_cart_id: number;
  commodity_id: number;
  commodity_detail_new?: string;
  parent_uid?: number;
  seller_on_sale?: number;
  main_tag?: MainTagJson;
  is_bargain?: number;
}

// 获取商品列表
export function commodityList(params: commodityListParams) {
  return request<ListDataJson<commodityListJson>>({
    method: 'GET',
    url: httpApi.tradingBankMybox.commodityList,
    params
  });
}

// 获取商品列表 v2（我要买）
export interface CommodityListV2Data extends ListDataJson<commodityListJson> {
  now_server_id?: number | string;
  now_server_name?: string;
}

export interface CommodityListV2Response {
  data: CommodityListV2Data;
  now_server_id?: number | string;
  now_server_name?: string;
}

export function commodityListV2(params: commodityListParams): Promise<CommodityListV2Response> {
  return request<ListDataJson<commodityListJson>>({
    method: 'GET',
    url: httpApi.tradingBankMybox.commodityListV2,
    params
  }) as unknown as Promise<CommodityListV2Response>;
}

interface commoditySellTypeData {
  game_id?: string;
}
interface commoditySellTypeJson {
  role_sell_switch: number;
  coin_sell_switch: number;
  equip_sell_switch: number;
}
// 获取商品出售类型
export function commoditySellType(data: commoditySellTypeData) {
  return request<commoditySellTypeJson>({
    method: 'POST',
    url: httpApi.tradingBankMybox.commoditySellType,
    data
  });
}

// 购物车配置
interface ShopCartConfParams {
  game_id?: string | number;
  sub_uid?: string | number;
}
export interface ShopCartConfProps {
  shop_cart_title: string;
  shop_cart_content: string;
  shop_cart_count: number;
  cart_add_max_num: number;
  auth_status: number;
  trade_coin: number;
  wx_shield: number;
  user_total_cart_count: number;
}
export function apiShopCartConf(data?: ShopCartConfParams) {
  return request<ShopCartConfProps>({
    method: 'POST',
    url: shopCartConf,
    data
  });
}
